var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallenges(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_24883)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.465 4.258l7.888 7.888a.5.5 0 01-.707.707L4.758 4.965 3.513 5H3.5a.5.5 0 01-.353-.147l-2.5-2.5A.499.499 0 011 1.5h1v-1a.5.5 0 01.854-.354l2.5 2.5c.098.097.15.23.146.367l-.034 1.245zM13.5 2c-2.527 0-4.85.86-6.706 2.294l.717.717A9.931 9.931 0 0113.5 3c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10c0-2.248.754-4.317 2.011-5.99l-.717-.716A10.938 10.938 0 002.5 13c0 6.075 4.925 11 11 11s11-4.925 11-11-4.925-11-11-11zm0 6a4.95 4.95 0 00-2.375.625l.735.735A3.964 3.964 0 0113.5 9c2.205 0 4 1.794 4 4s-1.795 4-4 4-4-1.794-4-4c0-.585.134-1.138.36-1.64l-.735-.735A4.95 4.95 0 008.5 13a5 5 0 105-5z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_24883"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
SvgChallenges.displayName = 'Challenges';
export default SvgChallenges;